import React, { useState } from 'react';

const ToggleButton = ({ onSelect, defaultValue = 'AC' }) => {
  const [selected, setSelected] = useState(defaultValue);

  const handleSelect = (option) => {
    setSelected(option);
    onSelect(option);
  };

  return (
    <div className="flex flex-col items-start my-3 ml-1">
      <h2 className="text-sm font-semibold mb-2">
        Choose your comfort
      </h2>
      <div className="flex rounded-xl border border-gray-300 p-1 w-36 justify-between">
        <button
          className={`flex-1 text-xs font-medium py-1.5 rounded-lg transition-all ${
            selected === 'AC' ? 'bg-sky-300 text-white shadow-md' : 'bg-transparent text-black'
          }`}
          onClick={() => handleSelect('AC')}
        >
          AC
        </button>
        <button
          className={`flex-1 text-xs font-medium py-1.5 rounded-lg transition-all ${
            selected === 'Non-AC' ? 'bg-red-300 text-white shadow-md' : 'bg-transparent text-black'
          }`}
          onClick={() => handleSelect('Non-AC')}
        >
          Non-AC
        </button>
      </div>
    </div>
  );
};

export default ToggleButton;
